import React, { Suspense, useEffect, useState } from 'react';

import useClientHydrated from '../../hooks/useClientHydrated';
import type { DrawerProps } from './DrawerClient';

const DrawerClient = !process.env.SERVER
  ? process.env.NODE_ENV === 'test'
    ? require('./DrawerClient').default
    : React.lazy(() => import('./DrawerClient'))
  : null;

function Drawer(props: DrawerProps) {
  const { isOpen } = props;
  const isHydrated = useClientHydrated();
  const [isClientOpen, setClientOpen] = useState(props.isOpen);
  const shouldRender = isHydrated || isOpen || isClientOpen;

  useEffect(() => {
    if (!isOpen) {
      setClientOpen(false);
      return;
    }

    if (process.env.NODE_ENV === 'test') {
      setClientOpen(true);
      return;
    }

    const frameId = window.requestAnimationFrame(() => {
      setClientOpen(true);
    });

    return () => window.cancelAnimationFrame(frameId);
  }, [isOpen]);

  const drawerProps = {
    ...props,
    isOpen: isClientOpen,
  };

  if (DrawerClient === null || !shouldRender) return null;

  if (process.env.NODE_ENV === 'test') {
    const TestDrawerClient = DrawerClient as React.ComponentType<DrawerProps>;
    return <TestDrawerClient {...drawerProps} />;
  }

  return (
    <Suspense fallback={null}>
      <DrawerClient {...drawerProps} />
    </Suspense>
  );
}

export default Drawer;
